import { ReactNode } from 'react';

import { useDraggable } from '@dnd-kit/core';

import { SireInfo } from '@/app/services/fertWork';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export type DraggableSireGroupProps = {
  sire: SireInfo;
  sourceRunId: string;
  children: ReactNode;
};

export const DraggableSireGroup = ({
  sire,
  sourceRunId,
  children,
}: DraggableSireGroupProps) => {
  const donorGroupRomanNumerals = useFeatureFlag(
    'Fert_Work_Donor_Group_Roman_Numerals',
  );
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: donorGroupRomanNumerals
      ? `siregroup-${sire.id}-${sire.semenType || ''}-${sire.collectionCode || ''}-${sire.note || ''}-${sourceRunId}`
      : `siregroup-${sire.id}-${sire.semenType || ''}-${sire.collectionCode || ''}-${sourceRunId}`,
    data: { sire, sourceRunId, type: 'sireGroup' },
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex items-center gap-1 ${isDragging ? 'opacity-50' : ''}`}
    >
      <div
        {...listeners}
        {...attributes}
        className="flex flex-shrink-0 cursor-grab touch-none items-center justify-center rounded p-0.5 transition-colors hover:bg-gray-200 active:bg-gray-300"
      >
        <div className="flex flex-col gap-[2px]">
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
        </div>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
